import React from 'react';
import styles from '../LandingPage.module.css';

const CtaSection = () => {
  return (
    <div className={styles.lightSection}>
      <div className={styles.section} style={{ paddingTop: '40px', paddingBottom: '120px' }}>
        <div style={{ 
          background: 'linear-gradient(135deg, #e0e7ff 0%, #fae8ff 50%, #e0f2fe 100%)', 
          borderRadius: '24px', 
          padding: '60px 40px', 
          textAlign: 'center',
          border: '1px solid rgba(255,255,255,0.5)',
          boxShadow: '0 20px 40px rgba(0,0,0,0.05)'
        }}>
          <h2 style={{ fontSize: '3rem', color: '#0f172a', marginBottom: '16px', fontWeight: 700, letterSpacing: '-0.02em' }}>
            Ready to build your GCC in India?
          </h2>
          <p style={{ color: '#475569', fontSize: '1.1rem', marginBottom: '40px', maxWidth: '600px', margin: '0 auto 40px auto' }}>
            Partner with Provaantech to launch, operate and scale your next-generation Global Capability Center.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="#consultation" className={styles.primaryButton}>
              Book GCC Consultation <span style={{ marginLeft: '4px' }}>→</span>
            </a>
            <a href="#talk" className={styles.secondaryButton} style={{ background: '#ffffff', color: '#0f172a', borderColor: '#e2e8f0' }}>
              Talk to GCC Experts
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaSection;
